import React from 'react'
import { SaveCancel, Checkbox, Radio } from '../../../components'
import Select from 'react-select'

const ExportPopup = ({onClose, isMobile}) => {
  const [form, setForm] = React.useState({
    export_type: 'exist',
  })

  const updateForm = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    })
  }

  const handleClose = (e) => {
    e.preventDefault()
    e.stopPropagation()

    onClose(false)
  }

  return (
    <div
      className="fixed left-0 top-0 w-full h-screen flex justify-center items-center"
      style={{zIndex: 900, background: 'rgba(0, 0, 0, 0.75)'}}
      onClick={handleClose}
    >
      <div className="container mx-auto" onClick={(e) => e.stopPropagation()}>
        <div className="lg:w-8/12 mx-auto p-5 lg:p-8 bg-white rounded">
          <h1 className="text-lg lg:text-3xl font-primary font-bold">Export to Program</h1>
          <hr className="mt-5 mb-5 lg:mb-10"/>
          <form>
            <div className="flex flex-wrap items-center mb-5 lg:mb-8">
              <Radio
                name="export_type"
                id="export_type1"
                label="Export to New Program"
                value="new"
                className="w-full lg:w-auto mb-3 lg:mb-0 mr-4"
                form={form}
                onChange={updateForm}
              />
              <Radio
                name="export_type"
                id="export_type2"
                label="Export to Existing Program"
                value="exist"
                className="w-full lg:w-auto "
                form={form}
                onChange={updateForm}
              />
            </div>

            {
              form.export_type === 'exist' &&
              <div className="mb-8">
                <p className="text-sm text-gray-444 mb-5">Choose existing program</p>
                <Select options={[]} className="w-full lg:w-2/3 text-sm"/>
              </div>
            }

            <div className="mb-8">
              <Checkbox
                className="mb-2"
                id="checkbox1"
                label="Export location"
                name="export_target"
                value="location"
                defaultChecked={true}
              />
              <Checkbox
                className="mb-2"
                id="checkbox2"
                label="Export tag"
                name="export_target"
                value="tag"
              />
            </div>

            <SaveCancel onClick={handleClose} to="/dashboard/events/form" saveText="Export"/>
          </form>
        </div>
      </div>
    </div>
  )
}

export { ExportPopup }